import { ChangeEvent, useState } from 'react'
import s from './FormFileUpload.modules.scss'
import { DeleteActionIcon } from 'icons'
import cn from 'classnames'

export interface FormFileUploadProps {
  icon: React.ReactNode
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  text?: string
  buttonContainerClassName?: string
  fileContainerClassName?: string
  showFile?: boolean
  accept?: string
}

const FormFileUpload = (props: FormFileUploadProps) => {
  const {
    onChange,
    icon,
    text,
    buttonContainerClassName,
    fileContainerClassName,
    showFile,
    accept
  } = props

  const [selectedFile, setSelectedFile] = useState(null)

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files[0]
    const imageURL = URL.createObjectURL(file)

    onChange(event)
    setSelectedFile(file)
  }

  const handleClearFile = () => {
    onChange(null)
    setSelectedFile(null)
  }

  return (
    <div>
      {selectedFile && showFile ? (
        <>
          <div className={cn(s.fileContainer, fileContainerClassName)}>
            <span className={s.text}>{selectedFile.name}</span>
            <div onClick={handleClearFile}>
              <DeleteActionIcon />
            </div>
          </div>
        </>
      ) : (
        <label htmlFor="file-upload">
          <div className={cn(s.buttonWrapper, buttonContainerClassName)}>
            {icon} {text || 'Alege fisier'}
            <input
              id="file-upload"
              type="file"
              onChange={handleFileChange}
              style={{ display: 'none' }}
              accept={accept}
            />
          </div>
        </label>
      )}
    </div>
  )
}

export default FormFileUpload
